
import { STRING } from "../SchemaTypes";
import { useParsedFieldProps } from "./useParsedFieldProps";
import { MAXIMUM_STRING_LENGTH } from "../../../helpers/FormValidator";
import Field from "../Field";
import StringInput from "../../Input/StringInput";

const StringField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = {
    type: STRING,
    parent,
    validations: {
      required,
      length: { maximum: MAXIMUM_STRING_LENGTH }
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <StringInput {...inputProps} />
    </Field>
  );
};

export default StringField;
